var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-page-template',{attrs:{"title":"Erreur 403","message":"Vous n'avez pas le droit d'accéder à cette page."}},[_c('b-btn',{staticClass:"mb-1",attrs:{"to":{ name: 'homepage' },"variant":"info"}},[_vm._v("Retour à l'accueil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }